export const SOCKET_EVENTS = {
  // 🚀 Transaction Events
  TRANSACTION_CREATED: 'transaction.created',
  TRANSACTION_INITIATED: 'transaction.initiated',
  TRANSACTION_PENDING: 'transaction.pending',
  TRANSACTION_SUCCESS: 'transaction.success',
  TRANSACTION_FAILED: 'transaction.failed',
  TRANSACTION_CANCELED: 'transaction.canceled',
  TRANSACTION_ABANDONED: 'transaction.abandoned',
  TRANSACTION_EXPIRED: 'transaction.expired',
  TRANSACTION_UPDATED: 'transaction.updated',

  // 💳 Payment Link Events
  PAYMENT_LINK_CREATED: 'payment_link.created',
  PAYMENT_LINK_EXPIRED: 'payment_link.expired',
  PAYMENT_LINK_USED: 'payment_link.used',

  // 🔔 Notification Events (admin, superadmin, etc.)
  NOTIFICATION_CREATED: 'notification.created',
  NOTIFICATION_READ: 'notification.read',

  // 🧪 Webhook Test or Delivery
  WEBHOOK_DELIVERY_SUCCESS: 'webhook.delivery.success',
  WEBHOOK_DELIVERY_FAILED: 'webhook.delivery.failed',
  WEBHOOK_TESTED: 'webhook.tested',

  // 👥 User or Auth events
  USER_CONNECTED: 'user.connected',
  USER_DISCONNECTED: 'user.disconnected',

  // 📦 Miscellaneous
  OTHERS_EVENTS: 'others',
};
